import React, { useState } from 'react';
import CreativeCards from './CreativeCards';
import FrequencyGenerator from './FrequencyGenerator';

import DreamAnalysisTool from './DreamAnalysisTool';
import BreathingExercise from './BreathingExercise';

const CreativeToolsView = ({ client }) => {
    const [activeTab, setActiveTab] = useState('cards'); // 'cards' | 'frequencies' | 'dreams'

    return (
        <div className="min-h-screen bg-white p-6">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-slate-800 mb-2 font-sans">
                        🎨 Strumenti Creativi
                    </h1>
                    <p className="text-slate-600 font-sans">
                        Tool per facilitare l'espressione emotiva e il lavoro interiore con {client.name}
                    </p>
                </div>

                {/* Tab Navigation */}
                <div className="bg-slate-100 rounded-2xl shadow-sm mb-6 p-1.5 flex gap-1.5 overflow-x-auto">
                    <button
                        onClick={() => setActiveTab('cards')}
                        className={`flex-1 py-3 px-6 rounded-xl font-medium transition whitespace-nowrap font-sans ${activeTab === 'cards'
                            ? 'bg-slate-900 text-white shadow-sm'
                            : 'text-slate-600 hover:bg-white hover:text-black'
                            }`}
                    >
                        🎴 Carte Creative
                    </button>
                    <button
                        onClick={() => setActiveTab('frequencies')}
                        className={`flex-1 py-3 px-6 rounded-xl font-medium transition whitespace-nowrap font-sans ${activeTab === 'frequencies'
                            ? 'bg-slate-900 text-white shadow-sm'
                            : 'text-slate-600 hover:bg-white hover:text-black'
                            }`}
                    >
                        🎵 Frequenze
                    </button>
                    <button
                        onClick={() => setActiveTab('dreams')}
                        className={`flex-1 py-3 px-6 rounded-xl font-medium transition whitespace-nowrap font-sans ${activeTab === 'dreams'
                            ? 'bg-slate-900 text-white shadow-sm'
                            : 'text-slate-600 hover:bg-white hover:text-black'
                            }`}
                    >
                        🌙 Analisi Sogni
                    </button>
                    <button
                        onClick={() => setActiveTab('breathing')}
                        className={`flex-1 py-3 px-6 rounded-xl font-medium transition whitespace-nowrap font-sans ${activeTab === 'breathing'
                            ? 'bg-slate-900 text-white shadow-sm'
                            : 'text-slate-600 hover:bg-white hover:text-black'
                            }`}
                    >
                        🌬️ Respirazione
                    </button>
                </div>

                {/* Content */}
                <div className="animate-fade-in">
                    {activeTab === 'cards' && <CreativeCards client={client} />}
                    {activeTab === 'frequencies' && <FrequencyGenerator client={client} />}
                    {activeTab === 'dreams' && <DreamAnalysisTool client={client} />}
                    {activeTab === 'breathing' && <BreathingExercise client={client} />}
                </div>
            </div>
        </div>
    );
};

export default CreativeToolsView;
